<template>
  <div>
    <defaultLayout
      :full-width="true"
    >
      <slot />
    </defaultLayout>
  </div>
</template>

<script lang="ts">
import defaultLayout from './default.vue';

export default defineComponent({
  name: 'DefaultFullWidth',
  components: {
    defaultLayout,
  },
});
</script>
